<template>
  <div>
    <div v-show="$store.state.operate!='添加'&&$store.state.operate!='编辑'&&$store.state.operate!='详情'&&$store.state.operate!='复制'" class="page-list">
	<com-page-title  @callbackOperate="callbackOperate" ></com-page-title>
	  <!-- 搜索栏 -->
	<el-form :inline="true"  class="demo-form-inline">
		<el-form-item  label="">
		    <el-date-picker prefix-icon="none"
		         v-model="form.dateRange"
		         type="datetimerange" :editable="false"
				 value-format='yyyy-MM-dd HH:mm:ss'
				  start-placeholder="开始日期"
				       end-placeholder="结束日期"
		         range-separator=""
				   @change="callbackIndex(1)">
		       </el-date-picker>
		  </el-form-item>
		   <el-form-item label="">
		 <el-button @click="callbackIndex(1)" type="primary">搜索</el-button>
		  </el-form-item>
		</el-form>
		
      <el-table
        :data="pageData"
        highlight-current-row
        style="width: 100%;"
		:height="$store.state.height-328"
		ref="multipleTable"
		@select-all="selectChange"
		@select="selectChange"
		@sort-change="sortChange">
	   <template slot="empty"><el-empty description="暂时没有数据"></el-empty> </template>
		      <el-table-column type="selection"></el-table-column>
		   <com-page-index></com-page-index>
		 <el-table-column prop='title' label='标题' ></el-table-column>
		 <el-table-column prop='subTitle' label='副标题' ></el-table-column>
		 <!-- <el-table-column prop='brief' label='内容' ></el-table-column> -->
		 <el-table-column prop='couponVal' label='价值' ></el-table-column>
		 <com-page-isshow></com-page-isshow>
		 <!-- <el-table-column prop='couponNum' label='数量' ></el-table-column> -->
		 <!-- <el-table-column prop='useTime' label='使用时间' ></el-table-column> -->
		 <!-- <el-table-column prop='closeTime' label='关闭时间' ></el-table-column> -->
		 <el-table-column prop='createTime' label='创建时间' ></el-table-column>
		 <!-- 操作按钮 -->
		<com-page-operate :columnList="columnList"  :pageData="pageData" @callbackOperate="callbackOperate"></com-page-operate>
      </el-table>
	    <!-- 分页页面 -->
	  <com-page-number @callbackOperate="callbackOperate" @callbackIndex="callbackIndex" ></com-page-number>
    </div>
	<!-- 表单页面 -->
    <div v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"> 
      <edit  @callbackPage="callbackPage"   :id="id"></edit>
    </div>
	<!-- 返回按钮 -->
	<com-page-return @callbackPage="callbackPage" v-if="$store.state.operate=='添加'||$store.state.operate=='编辑'||$store.state.operate=='详情'||$store.state.operate=='复制'"></com-page-return>
	<!-- 导入页面 -->
	<com-page-import @callbackImport="callbackImport"  v-if="$store.state.operate=='导入'"></com-page-import>
	<!-- 导出页面 -->
	<com-page-export  v-if="$store.state.operate=='导出'"></com-page-export>
 <!-- 账号配置列 -->
	<com-page-columns  @callbackColumns="callbackColumns"  v-if="$store.state.operate=='配置列'"></com-page-columns>
 </div>
</template>
<script>
import edit from "@/components/edit/com-edit-coupon"; 
export default {
  components: {edit },
  data() {
    return {
	columnList:[],//权限列
		pageData:[],//页面数据
		id:'',//表单主键id
		form:{//搜索表单
			dateRange: this.$dateRangeCurrent,//时间
		},
    };
  },
   watch: {
      $route(to,from){ //路由监听
	   this.form.dateRange=this.$dateRangeCurrent;
        }
     },
  methods: {
   callbackImport(){//导入回调
		   this.callbackIndex(1)
	  },
	   selectChange(selection,row){//选择
	  this.$store.commit("saveSelect", selection);
	  },
	  sortChange(column){//排序回调
		var list= this.$store.state.list;
		list.pageOrder=column.order == 'descending'?'desc':'asc';
		list.pageSort=column.prop;
		this.$store.commit("saveList", list);
		 this.callbackIndex(1)
	},
	  callbackOperate(e){//操作按钮事件
		  if(e.operate=='添加')
			  this.id="";
		   if(e.operate=='复制'||e.operate=='编辑'||e.operate=='详情')
			  this.id=(e.data.id||'').toString();
		if(e.operate=='删除'){
		var id=this.$store.state.select.map(item=>item.id).join(',');
		 localStorage.setItem('SELECTIDS',id)
				this.$axios.post(`/api/Coupon/PostCouponDeleteWhere` ,'').then(e => {
					 this.$message.success('删除成功到同步服务器');
							this.callbackIndex(this.pageIndex);
				  }); 
		}
	  },
	  callbackPage(e){//表单返回事件
		  if(e.statusText=='添加'||e.statusText=='编辑'){
		    this.$store.commit("saveOperate", "");
			   this.$message.success('提交成功同步到服务器');
			this.callbackIndex(1);
		  }
	  },
    callbackIndex(i) {//获取分页数据
       var data=this.$pageParams(this.form,i)
      this.$axios.get(`/api/Coupon/GetCouponPage`,data).then(e => {
		 this.$store.commit("saveList", e);
			this.pageData=e.pageData;
        });
    }
  },
  mounted() {//页面加载事件
     this.$store.commit("saveList", {});
   this.callbackIndex(1)  
  }
  
};
</script>
<style>
</style>

